<template>
  <div id="app">
    <!-- testing -->
    <!-- <iframe
      :src="
        `https://lab3859.solenaverde.com/area/${this.soilArea}/sampleProfileSampler`
      "
      scrolling="no"
      style="overflow:hidden;"
    ></iframe> -->
    <!-- production -->
    <iframe
      :src="
        `https://lab.solenagreen.com/area/${this.soilArea}/sampleProfileSampler`
      "
    ></iframe>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data: () => ({
    soilArea: "",
  }),
  created() {
    this.SET_APPBAR_OPTIONS({
      leftButton: "back-arrow",
      funcLeftButton: this.goBack,
    });
    this.soilArea = this.$route.params.id;
  },
  methods: {
    ...mapMutations(["SET_APPBAR_OPTIONS"]),

    goBack() {
      this.$router.push(`/samples?fromAreaDetail=true`);
    },
  },
};
</script>

<style scoped>
#app,
#app iframe {
  height: 100vh;
  width: 100%;
  border: none;
  box-sizing: border-box;
}
</style>
